import ChooseService from "./ChooseService/ChooseService";
import ChooseStaff from "./ChooseStaff/ChooseStaff";
import ChooseDateTime from "./ChooseDateTime/ChooseDateTime";
import useAppointment from "../../hooks/useAppoitnment";
function Appointment() {
  const {
    step,
    setStep,
    disableNext,
    services,
    selectedServices,
    availableStaffList,
    onToggleService,
    staffList,
    selectedStaff,
    onSelectStaff,
    selectedDate,
    setSelectedDate,
    selectedTime,
    setSelectedTime,
    availableTimes,
    unavailability,
    shopClosedDays,
    shopClosedWeekDays,
    handleConfirmBooking,
    handleQuantityChange,
    goNext,
    goBack,
    mainPageRef,
  } = useAppointment();

  return (
    <div id="main-page">
      {/* Step Indicator (optional) */}

      {step === 1 && (
        <ChooseService
          groupedServices={services}
          selectedServices={selectedServices}
          onToggleService={onToggleService}
          handleQuantityChange={handleQuantityChange}
        ></ChooseService>
      )}
      {step === 2 && (
        <ChooseStaff
          staffList={staffList}
          availabelStaffList={availableStaffList}
          selectedStaff={selectedStaff}
          onSelectStaff={onSelectStaff}
        ></ChooseStaff>
      )}
      {step === 3 && (
        <ChooseDateTime
          selectedStaff={selectedStaff}
          selectedServices={selectedServices}
          selectedTime={selectedTime}
          setSelectedTime={setSelectedTime}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          availableTimes={availableTimes}
          unavailability={unavailability}
          shopClosedDays={shopClosedDays}
          shopClosedWeekDays={shopClosedWeekDays}
        />
      )}
      {step === 4 && (
        <div>
          <h3 className="mb-4">Review & Confirm</h3>
          <div className="card appiontment-reviewCard mb-3 ">
            <div className="card-body">
              <p className="card-text">
                {/* Services */}

                <div className="mb-3">
                  <strong className="me-2">Service(s):</strong>
                  <ul className="list-inline d-inline-flex flex-wrap gap-2 mb-0">
                    {selectedServices.map((s) => (
                      <li key={s.name} className="list-inline-item">
                        <span className="badge  text-muted">
                          {`${s.quantity > 1 ? `${s.quantity}x ` : ``}${
                            s.name
                          }`}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Staff */}
                <div className="mb-2">
                  <strong className="me-2">Staff:</strong>
                  <span className="badge  text-muted">
                    {selectedStaff?.name}
                  </span>
                </div>

                {/* Date */}
                <div className="mb-2">
                  <strong className="me-2">Date:</strong>
                  <span className="badge text-muted">
                    {selectedDate?.toLocaleDateString()}
                  </span>
                </div>

                {/* Time */}
                <div className="mb-2">
                  <strong className="me-2">Time:</strong>
                  <span className="badge text-muted">{selectedTime || ""}</span>
                </div>
              </p>
            </div>
          </div>
        </div>
      )}
      {/* Navigation Buttons */}
      <div className="d-flex justify-content-between mt-4">
        <button
          className="btn btn-secondary"
          disabled={step === 1}
          onClick={goBack}
        >
          Back
        </button>

        {step < 4 && (
          <button
            className="btn btn-primary"
            disabled={disableNext}
            onClick={goNext}
          >
            Next
          </button>
        )}
        {step == 4 && (
          <button className="btn btn-primary" onClick={handleConfirmBooking}>
            Confirm Booking
          </button>
        )}
      </div>
    </div>
  );
}

export default Appointment;
